import { omit } from 'lodash';
import { ITokens, ITokenStore, TokenTypes } from './TokenStore';

/**
 * Stores tokens in memory locally
 */
export class LocalTokenStore implements ITokenStore {
  private _tokens: ITokens;
  environment?: string;

  constructor(tokens?: ITokens) {
    this._tokens = tokens || {};
  }

  updateTokens(tokens: ITokens) {
    Object.assign(this._tokens, tokens);
  }

  set id(token) {
    this._tokens.id = token;
  }

  set access(token) {
    this._tokens.access = token;
  }

  set refresh(token) {
    this._tokens.refresh = token;
  }

  set restricted(token) {
    this._tokens.restricted = token;
  }

  get id() {
    return this._tokens.id;
  }

  get refresh() {
    return this._tokens.refresh;
  }

  get access() {
    return this._tokens.access;
  }

  get restricted() {
    return this._tokens.restricted;
  }

  // TODO figure out how to remove the any here
  async clear(tokensToClear?: TokenTypes[]): Promise<any> {
    if (tokensToClear) {
      this._tokens = omit(this._tokens, tokensToClear);
    } else {
      this._tokens = {};
    }
  }


}
